<div class="background" fxLayout="column">
  <div class="container" fxFlex.lt-md="100" fxFlex="50">
    <!-- <div class="title" fxLayoutAlign="center center">{{systemTitle}}</div> -->
    <div class="container__title">
      <img src="{{ logo }}" class="logo" />
    </div>
    <div class="container__box">
      <div class="container__box__form" fxLayout="column">
        <form [formGroup]="loginForm" class="form" novalidate>
          <mat-form-field class="form__input" appearance="outline">
            <mat-label>Usuário</mat-label>
            <mat-icon matPrefix style="margin-right: 25px">people</mat-icon>
            <input
              matInput
              formControlName="username"
              name="username"
              placeholder="Usuario"
            />
            <mat-error *ngIf="loginForm.controls['username'].invalid">{{
              getErrorMessage("username")
            }}</mat-error>
          </mat-form-field>

          <mat-form-field class="form__input" appearance="outline">
            <mat-label>Senha</mat-label>
            <mat-icon matPrefix style="margin-right: 25px">vpn_key</mat-icon>
            <input
              matInput
              formControlName="password"
              name="password"
              placeholder="Senha"
              type="{{ showPassword ? 'text' : 'password' }}"
            />
            <mat-icon
              matSuffix
              (click)="handleChangeVisibilityPassword()"
              class="form__icon"
            >
              {{ showPassword ? "visibility" : "visibility_off" }}
            </mat-icon>
            <mat-error *ngIf="loginForm.controls['password'].invalid">{{
              getErrorMessage("password")
            }}</mat-error>
          </mat-form-field>

          <mat-form-field class="form__input" appearance="outline">
            <mat-label>Ambiente</mat-label>
            <mat-icon matPrefix style="margin-right: 25px">settings</mat-icon>
            <mat-select formControlName="umovmeEnvironment">
              <mat-option
                *ngFor="let item of umovmeEnvironments"
                [value]="item"
                [selected]="item.default == true"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </form>

        <div
          class="form__buttom-search"
          fxLayoutAlign="center center"
          fxLayoutAlign.lt-md="center center"
          fxLayout="row"
          fxLayout.lt-md="column"
          fxFlex="100"
        >
          <button
            mat-raised-button
            class="form__buttom-search__buttom"
            (click)="handleLogin()"
            [disabled]="loginForm.invalid"
          >
            Fazer Login
          </button>
        </div>

        <div
          class="forgot-password"
          fxLayoutAlign="center center"
          (click)="showForgotPassword()"
        >
          Não conseguiu entrar?
        </div>
      </div>
    </div>
  </div>

  <div fxFlex="100" fxFlex.lt-md="5" fxLayout="row" fxLayoutAlign="end end">
    Versão {{ version }} - {{ environmentName }}
  </div>
</div>
